export default function Paper(theme) {
  const isDark = theme.palette.mode === 'dark';

  return {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          // Increase blur for stronger melted glass effect
          backdropFilter: 'blur(32px) saturate(200%)',
          WebkitBackdropFilter: 'blur(32px) saturate(200%)', // Safari support
        },
        elevation1: {
          boxShadow: isDark 
            ? '0 4px 16px 0 rgba(0, 0, 0, 0.3)' 
            : '0 4px 16px 0 rgba(31, 38, 135, 0.05)',
        },
        elevation2: {
          boxShadow: isDark 
            ? '0 8px 32px 0 rgba(0, 0, 0, 0.4)' 
            : '0 8px 32px 0 rgba(31, 38, 135, 0.1)',
        }
      }
    }
  };
}
